import { TitleStyle } from "./style"

export const Title: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <TitleStyle>
            {children}
        </TitleStyle>
    )
}